import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isArray from 'lodash/isArray';
import { Alert as BootstrapAlert } from 'react-bootstrap';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';

// STYLES
import styles from './dismissable.module.scss';

// MAIN COMPONENT
const Alert = ({ onClose, children, message, variant, className }) => {
  return (
    <BootstrapAlert
      variant={variant}
      className={clsx('d-flex justify-content-between mt-4 large', styles.alert, className)}
    >
      {isArray(message) ? (
        <ul className="mb-0 ps-3">
          {message.map((m, i) => (
            <li key={i} className={clsx(i !== message.length - 1 && 'mb-2')}>
              {m}
            </li>
          ))}
        </ul>
      ) : (
        <span>{message || children}</span>
      )}
      {onClose ? (
        <div onClick={onClose} className={styles.close}>
          <Sprite use="cancel-circle" />
        </div>
      ) : null}
    </BootstrapAlert>
  );
};

// EXPORT
export default Alert;
